<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48" >
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="项目">
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                :disabled="showable"
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="时间">
              <a-range-picker @change="onChange" v-model="clearDate"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam = {},queryParam.dailyType = 'curing',clearDate=undefined}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
        <a-row :gutter="48" style="height:50px">
          <a-col>
            <a-button type="primary" icon="download" @click="download">Excel导出</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      :isInquire="false"
      bordered
      disabled="showable"
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
  </a-card>
</template>
<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { dropProjectByType } from '@/api/project/ProjectInfo'
import { newFetchList, download } from '@/api/statement/projectCost'
import ARow from 'ant-design-vue/es/grid/Row'
import ACol from 'ant-design-vue/es/grid/Col'

export default {
  name: 'ProjectCost',
  components: { ACol, ARow },
  mixins: [TableMixin],
  data () {
    return {
      projectList: [], // 项目
      supplierList: [], // 供货人
      purchaserList: [], // 采购人
      showable: false,
      clearDate: undefined,
      queryParam: {
        projectId: undefined,
        startTime: undefined,
        endTime: undefined,
        dailyType: 'curing'
      },
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      },
      loadData: parameter => {
        return newFetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName',
          width: '30%'
        },
        {
          title: '日期',
          dataIndex: 'dailyDate'
        },
        {
          title: '自有人工',
          dataIndex: 'workPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '外雇人工',
          dataIndex: 'hireWorkPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '外部机械',
          dataIndex: 'outMachinePrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '现金支付',
          dataIndex: 'otherPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    onChange (value, dateString) {
      this.queryParam.startTime = moment(dateString[0]).startOf('day').format('YYYY-MM-DD HH-mm-ss')
      this.queryParam.endTime = moment(dateString[1]).endOf('day').format('YYYY-MM-DD HH-mm-ss')
      if (this.queryParam.startTime === 'Invalid date') {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },
    init () {
      dropProjectByType('curing').then(res => {
        this.projectList = res.data
        this.queryParam.projectId = res.data[0].value
        this.queryPage()
      })
    },
    download () {
      download(this.queryParam).then(res => {
        const blbo = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blbo)
        link.download = '日报信息汇总.xlsx'
        link.click()
      }).catch((e) => {
        this.$message.warning('下载失败')
      })
    }

  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
